<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label">Clientes:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGraficas" v-model="Filtro.IdCliente" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Clientes" :key="ind" :value="item.IdAgente">{{item.NombreComercial}}</option>
                    </select>
                </div>

                <div class="col-auto">
                    <label class="col-form-label">Contactos:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGraficas" v-model="Filtro.IdContacto" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Contactos" :key="ind" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
                    </select>
                </div>

                <div class="col-auto">
                    <label class="col-form-label">Asignado a:</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGraficas" v-model="Filtro.IdVendedor" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Vendedores" :key="ind" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
                    </select>
                </div>

                <div class="col-auto">
                    <label for="">{{ BndRango ? 'Por Meses' : 'Por Rango' }}</label>
                </div>

                <div class="col-auto">
                    <button @click="CambiarRango" class="btn btn-primary"><i :class="BndRango ? 'fa fa-arrow-left' : 'fa fa-arrow-right'"></i></button>
                </div>

                <div class="col-auto" v-if="!BndRango">
                    <select @change="GetDatosGraficas" v-model="Filtro.Mes" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Meses" :key="ind" :value="item.Value">{{item.Tag}}</option>
                    </select>
                </div>

                <div class="col-auto" v-if="!BndRango">
                    <select @change="GetDatosGraficas" v-model="Filtro.Anio" class="form-select form-control-search">
                        <option v-for="(item,ind) in Anios" :key="ind" :value="item">{{item}}</option>
                    </select>
                </div>

                <div class="col-auto" v-if="BndRango">
                    <Datepicker @input="GetDatosGraficas" v-model="Filtro.Inicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                </div>

                <div class="col-auto" v-if="BndRango">
                    <Datepicker @input="GetDatosGraficas" v-model="Filtro.Fin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                </div>
            </template>

            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <div class="row mt-3">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <nav>
                                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button type="button" class="nav-link active" id="nav-coordinador-tab" data-bs-toggle="tab" data-bs-target="#nav-coordinador" role="tab" aria-controls="nav-coordinador" aria-selected="false">
                                            Coord / Gerentes
                                        </button>
                                        <button type="button" class="nav-link" id="nav-parejas-tab" data-bs-toggle="tab" data-bs-target="#nav-parejas" role="tab" aria-controls="nav-parejas" aria-selected="false">
                                            Parejas / Grupos
                                        </button>
                                    </div>
                                </nav>
        
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active" id="nav-coordinador" role="tabpanel" aria-labelledby="nav-coordinador-tab">
                                        <div class="row mt-3">
                                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                                <div class="card text-white bg-success h-100">
                                                    <div class="card-body">
                                                        <div class="card-body-icon">
                                                            <i class="fa fa-fw fa-tags"></i>
                                                        </div>
                                                        <h5 class="text-white">
                                                            ESP - Encuestas
                                                            <br>
                                                            Resueltas {{ ObjEncuestas.ContadorResueltasCoordinador }}
                                                        </h5>
                                                    </div>
                                                    <div class="card-footer clearfix small z-index-1">
                                                        <span style="float:left;font-size:15px;">Encuestas Pendientes</span>
                                                        <span style="float:right; width:30px">
                                                            <div class="circNum">
                                                                <p>{{ ObjEncuestas.ContadorPendientesCoordinador }}</p>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                                <div class="card text-white bg-info h-100">
                                                    <div class="card-body">
                                                        <div class="card-body-icon">
                                                            <i class="fa fa-fw fa-percent"></i>
                                                        </div>
                                                        <h5 class="text-white">
                                                            Porcentaje de Satisfacción
                                                            <br>
                                                            <span style="font-size: 25px;">
                                                                <strong>{{ ObjEncuestas.PorcentajeSatisfaccionCoordinador }}</strong>
                                                            </span>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div v-for="(item,index) in ObjEncuestas.ListaPreguntas" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                <div class="card mt-3">
                                                    <div class="card-header bg-dark pb-0 pt-3">
                                                        <h6 class="text-white">{{index+1 + ' - ' + item.Pregunta}}</h6>
                                                    </div>
                                                    <div class="card-body">
                                                        <div v-if="item.Grafica!=undefined" :id="'grafica'+index">
                                                            <apexchart :width="item.Grafica.width" :type="item.Grafica.type" :options="item.Grafica.options" :series="item.Grafica.series"></apexchart>
                                                        </div>
                                                        <div v-else style="height:400px;overflow-y:auto">
                                                            <div v-for="(Respuesta,index2) in item.Respuestas" :key="index2">
                                                                <i class="fa fa-circle"></i> <span>{{ Respuesta.RespuestaText }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade show" id="nav-parejas" role="tabpanel" aria-labelledby="nav-parejas-tab">
                                        <div class="row mt-3">
                                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                                <div class="card text-white bg-success h-100">
                                                    <div class="card-body">
                                                        <div class="card-body-icon">
                                                            <i class="fa fa-fw fa-tags"></i>
                                                        </div>
                                                        <h5 class="text-white">
                                                            ESP - Encuestas
                                                            <br>
                                                            Resueltas {{ ObjEncuestas.ContadorResueltasParejaEsp }}
                                                        </h5>
                                                    </div>
                                                    <div class="card-footer clearfix small z-index-1">
                                                        <span style="float:left;font-size:15px;">Encuestas Pendientes</span>
                                                        <span style="float:right; width:30px">
                                                            <div class="circNum">
                                                                <p>{{ ObjEncuestas.ContadorPendientesParejaEsp }}</p>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                                <div class="card text-white bg-info h-100">
                                                    <div class="card-body">
                                                        <div class="card-body-icon">
                                                            <i class="fa fa-fw fa-percent"></i>
                                                        </div>
                                                        <h5 class="text-white">
                                                            Porcentaje de Satisfacción
                                                            <br>
                                                            <span style="font-size: 25px;">
                                                                <strong>{{ ObjEncuestas.PorcentajeSatisfaccionParejaEsp }}</strong>
                                                            </span>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                                <div class="card text-white bg-success h-100">
                                                    <div class="card-body">
                                                        <div class="card-body-icon">
                                                            <i class="fa fa-fw fa-tags"></i>
                                                        </div>
                                                        <h5 class="text-white">
                                                            ING - Encuestas
                                                            <br>
                                                            Resueltas {{ ObjEncuestas.ContadorResueltasParejaEng }}
                                                        </h5>
                                                    </div>
                                                    <div class="card-footer clearfix small z-index-1">
                                                        <span style="float:left;font-size:15px;">Encuestas Pendientes</span>
                                                        <span style="float:right; width:30px">
                                                            <div class="circNum">
                                                                <p>{{ ObjEncuestas.ContadorPendientesParejaEng }}</p>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                                <div class="card text-white bg-info h-100">
                                                    <div class="card-body">
                                                        <div class="card-body-icon">
                                                            <i class="fa fa-fw fa-percent"></i>
                                                        </div>
                                                        <h5 class="text-white">
                                                            Porcentaje de Satisfacción
                                                            <br>
                                                            <span style="font-size: 25px;">
                                                                <strong>{{ ObjEncuestas.PorcentajeSatisfaccionParejaEng }}</strong>
                                                            </span>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h6>Selecciona el Idioma de las Encuestas</h6>
                                                <div class="row">
                                                    <div class="col-lg-1">
                                                        <div class="form-check">
                                                            <input type="radio" id="espanol" v-model="IdiomaParejas" value="ESP" class="form-check-input">
                                                            <label class="form-check-label" for="espanol">Español</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-1">
                                                        <div class="form-check">
                                                            <input type="radio" id="ingles" v-model="IdiomaParejas" value="ING" class="form-check-input">
                                                            <label class="form-check-label" for="ingles">Inglés</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="row" v-if="IdiomaParejas=='ESP'">
                                            <div v-for="(item,index) in ObjEncuestas.ListaPreguntasParejasEsp" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                <div class="card mt-3">
                                                    <div class="card-header bg-dark pb-0 pt-3">
                                                        <h6 class="text-white">{{index+1 + ' - ' + item.Pregunta}}</h6>
                                                    </div>
                                                    <div class="card-body">
                                                        <div v-if="item.Grafica!=undefined" :id="'grafica'+index">
                                                            <apexchart :width="item.Grafica.width" :type="item.Grafica.type" :options="item.Grafica.options" :series="item.Grafica.series"></apexchart>
                                                        </div>
                                                        <div v-else style="height:400px;overflow-y:auto">
                                                            <div v-for="(Respuesta,index2) in item.Respuestas" :key="index2">
                                                                <i class="fa fa-circle"></i> <span>{{ Respuesta.RespuestaText }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="row" v-else>
                                            <div v-for="(item,index) in ObjEncuestas.ListaPreguntasParejasEng" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                <div class="card mt-3">
                                                    <div class="card-header bg-dark pb-0 pt-3">
                                                        <h6 class="text-white">{{index+1 + ' - ' + item.Pregunta}}</h6>
                                                    </div>
                                                    <div class="card-body">
                                                        <div v-if="item.Grafica!=undefined" :id="'grafica'+index">
                                                            <apexchart :width="item.Grafica.width" :type="item.Grafica.type" :options="item.Grafica.options" :series="item.Grafica.series"></apexchart>
                                                        </div>
                                                        <div v-else style="height:400px;overflow-y:auto">
                                                            <div v-for="(Respuesta,index2) in item.Respuestas" :key="index2">
                                                                <i class="fa fa-circle"></i> <span>{{ Respuesta.RespuestaText }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </CLoader>
            </template>
        </CList>
    </div>
</template>

<script>
import Calendar from '@/helpers/StaticComboBox.js';
const EmitEjecuta='seccionRendimientoEncuestas';

export default {
    name:"Principal",
    data() {
        return {
            ConfigList:{
                Title:'Rendimiento Encuestas',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: true,
                ShowPaginador: false,
                ShowSearch:false,
                ShowEntradas:false,
                TypeBody: 'Form',
				TitleFirst: 'CRM',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:false
            },
            Filtro:{
                IdCliente:'',
                IdContacto:'',
                IdVendedor:'',
                Mes:'',
                Anio:new Date().getFullYear(),
                Rango:false,
                Inicio:'',
                Fin:''
                // Anio:'2023'
            },
            segurity:{},
            Setpicker:Calendar.calendarSettings,
            Clientes:[],
            Contactos:[],
            Vendedores:[],
            Meses:[
                {Tag:"Enero",Value:"1"},
                {Tag:"Febrero",Value:"2"},
                {Tag:"Marzo",Value:"3"},
                {Tag:"Abril",Value:"4"},
                {Tag:"Mayo",Value:"5"},
                {Tag:"Junio",Value:"6"},
                {Tag:"Julio",Value:"7"},
                {Tag:"Agosto",Value:"8"},
                {Tag:"Septiembre",Value:"9"},
                {Tag:"Octubre",Value:"10"},
                {Tag:"Noviembre",Value:"11"},
                {Tag:"Diciembre",Value:"12"}
            ],
            Anios:[],
            ObjEncuestas:{
                ContadorResueltasCoordinador:0,
                ContadorPendientesCoordinador:0,
                ContadorResueltasParejaEsp:0,
                ContadorPendientesParejaEsp:0,
                ContadorResueltasParejaEng:0,
                ContadorPendientesParejaEng:0,
                PorcentajeSatisfaccionCoordinador:0,
                PorcentajeSatisfaccionParejaEsp:0,
                PorcentajeSatisfaccionParejaEng:0,
                ListaPreguntas:[],
                ListaPreguntasParejasEsp:[],
                ListaPreguntasParejasEng:[]
            },
            BndRango:false,
            IdiomaParejas:'ESP'
        }
    },
    methods: {
        async GetDatosGraficas(){
            this.ConfigLoad.ShowLoader=true;
            let FechaInicio='';
            let FechaFin='';
            if (this.Filtro.Inicio!='') {
                let YearInicio=this.Filtro.Inicio.getFullYear();
                let MonthInicio=this.Filtro.Inicio.getMonth()+1;
                let DayInicio=this.Filtro.Inicio.getDate();
                FechaInicio=YearInicio+'-'+MonthInicio+'-'+DayInicio;
            }
            if (this.Filtro.Fin!='') {
                let YearFin=this.Filtro.Fin.getFullYear();
                let MonthFin=this.Filtro.Fin.getMonth()+1;
                let DayFin=this.Filtro.Fin.getDate();
                FechaFin=YearFin+'-'+MonthFin+'-'+DayFin;
            }
            await this.$http.get("encuestaGrafica",{
                params:{
                    IdCliente:this.Filtro.IdCliente,
                    IdContacto:this.Filtro.IdContacto,
                    IdVendedor:this.Filtro.IdVendedor,
                    Mes:this.Filtro.Mes,
                    Anio:this.Filtro.Anio,
                    Rango:this.Filtro.Rango,
                    Inicio:FechaInicio,
                    Fin:FechaFin,
                }
            }).then((res)=>{
                this.ObjEncuestas.ContadorResueltasCoordinador=res.data.data.ContadorResueltasCoordinador;
                this.ObjEncuestas.ContadorResueltasParejasEsp=res.data.data.ContadorResueltasParejasEsp;
                this.ObjEncuestas.ContadorResueltasParejasEng=res.data.data.ContadorResueltasParejasEng;
                this.ObjEncuestas.ContadorPendientesCoordinador=res.data.data.ContadorPendientesCoordinador;
                this.ObjEncuestas.ContadorPendientesParejasEsp=res.data.data.ContadorPendientesParejasEsp;
                this.ObjEncuestas.ContadorPendientesParejasEng=res.data.data.ContadorPendientesParejasEng;
                this.ObjEncuestas.PorcentajeSatisfaccionCoordinador=res.data.data.SatisfaccionCoordinador+'%';
                this.ObjEncuestas.PorcentajeSatisfaccionParejaEsp=res.data.data.SatisfaccionParejasEsp+'%';
                this.ObjEncuestas.PorcentajeSatisfaccionParejaEng=res.data.data.SatisfaccionParejasEng+'%';
                // ENCUESTAS COORDINADOR
                let contador=0;
                // this.ObjEncuestas.ListaPreguntas=res.data.data.Preguntas;
                res.data.data.DatosGrafica.Preguntas=[];
                res.data.data.DatosGraficaParejas.PreguntasParejasEsp=[];
                res.data.data.DatosGraficaParejas.PreguntasParejasEng=[];
                res.data.data.DatosGrafica.OpcionesBase.forEach((element)=>{
                    let Grafica={
                        type:'bar',
                        width:'80%',
                        options: {
                            chart: {
                                id: 'grafica'+contador,
                                offsetX:50
                            },
                            title: {
                                text: 'Opciones Base',
                                align: 'center'
                            },
                        },
                        series: [{
                            name: 'Respuestas',
                            data: element.Datos
                        }]
                    }
                    res.data.data.DatosGrafica.Preguntas.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    contador++;
                });
                res.data.data.DatosGrafica.OpcionesEncuesta.forEach((element)=>{
                    let Labels=[];
                    let Values=[];
                    element.Datos.forEach((Dato)=>{
                        Labels.push(Dato.label);
                        Values.push(Dato.value);
                    });
                    let Grafica={
                        width: '80%',
                        type:'pie',
                        options:{
                            chart:{
                                id:'grafica'+contador,
                                offsetX:70
                            },
                            title: {
                                text: 'Opciones de Encuesta',
                                align: 'center'
                            },
                            labels:Labels,
                        },
                        series:Values
                    }
                    res.data.data.DatosGrafica.Preguntas.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    contador++;
                });
                res.data.data.DatosGrafica.OpcionesAnexadas.forEach((element)=>{
                    let Grafica={
                        width:'80%',
                        type:'pie',
                        options:{
                            chart:{
                                id:'grafica'+contador,
                                offsetX:70
                            },
                            title: {
                                text: 'Respuestas Anexadas',
                                align: 'center'
                            },
                            labels:element.Labels
                        },
                        series:element.Series
                    }
                    res.data.data.DatosGrafica.Preguntas.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    contador++;
                });
                res.data.data.DatosGrafica.OpcionesValoracion.forEach((element)=>{
                    let Labels=[];
                    let Values=[];
                    element.Datos.forEach((Dato)=>{
                        Labels.push(Dato.label);
                        Values.push(Dato.value);
                    });
                    let Grafica={
                        type:'line',
                        width:'80%',
                        options:{
                            chart:{
                                id:'grafica'+contador,
                                offsetX:60
                            },
                            stroke:{
                                curve:'smooth',
                                width:3
                            },
                            xaxis:{
                                categories:Labels
                            },
                            yaxis:{
                                decimalsInFloat:0
                            },
                            dataLabels:{
                                enabled:true,
                                background:{
                                    borderRadius:10
                                }
                            },
                            fill:{
                                colors:['#3B97B2']
                            },
                            title: {
                                text: 'Puntuación por Pregunta',
                                align: 'center'
                            },
                        },
                        series: [{
                            name: "Votos de Personas",
                            data: Values,
                            color:"#3B97B2"
                        }],
                    }
                    res.data.data.DatosGrafica.Preguntas.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    contador++;
                });
                res.data.data.DatosGrafica.OpcionesSiNo.forEach((element)=>{
                    let Grafica={
                        type:'bar',
                        width:'80%',
                        options:{
                            chart:{
                                id: 'grafica'+contador,
                                stacked: true,
                                stackType: '100%',
                                offsetX:70
                            },
                            xaxis:{
                                categories:element.Labels
                            },
                            title: {
                                text: 'Porcentaje de Respuesta SI - NO',
                                align: 'center'
                            },
                        },
                        series:[
                            {
                                name:'SI',
                                data:element.SerieSi
                            },
                            {
                                name:'NO',
                                data:element.SerieNo
                            },
                        ]
                    }
                    res.data.data.DatosGrafica.Preguntas.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    contador++;
                });
                res.data.data.DatosGrafica.OpcionesAbiertas.forEach((element)=>{
                    res.data.data.DatosGrafica.Preguntas.push(
                        {
                            IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,
                            Pregunta:element.Pregunta,
                            Respuestas:element.Respuestas
                        }
                    );
                });

                //ENCUESTAS PAREJAS
                res.data.data.DatosGraficaParejas.OpcionesBase.forEach((element)=>{
                    let Grafica={
                        type:'bar',
                        width:'80%',
                        options: {
                            chart: {
                                id: 'grafica'+contador,
                                offsetX:50
                            },
                            title: {
                                text: 'Opciones Base',
                                align: 'center'
                            },
                        },
                        series: [{
                            name: 'Respuestas',
                            data: element.Datos
                        }]
                    }
                    if (element.Idioma=='ESP') {
                        res.data.data.DatosGraficaParejas.PreguntasParejasEsp.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    else{
                        res.data.data.DatosGraficaParejas.PreguntasParejasEng.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    contador++;
                });
                res.data.data.DatosGraficaParejas.OpcionesEncuesta.forEach((element)=>{
                    let Labels=[];
                    let Values=[];
                    element.Datos.forEach((Dato)=>{
                        Labels.push(Dato.label);
                        Values.push(Dato.value);
                    });
                    let Grafica={
                        width: '70%',
                        type:'pie',
                        options:{
                            chart:{
                                id:'grafica'+contador,
                                offsetX:70
                            },
                            title: {
                                text: 'Opciones de Encuesta',
                                align: 'center'
                            },
                            labels:Labels,
                        },
                        series:Values
                    }
                    if (element.Idioma=='ESP') {
                        res.data.data.DatosGraficaParejas.PreguntasParejasEsp.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    else{
                        res.data.data.DatosGraficaParejas.PreguntasParejasEng.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    contador++;
                });
                res.data.data.DatosGraficaParejas.OpcionesAnexadas.forEach((element)=>{
                    let Grafica={
                        width:'80%',
                        type:'pie',
                        options:{
                            chart:{
                                id:'grafica'+contador,
                                offsetX:70
                            },
                            title: {
                                text: 'Respuestas Anexadas',
                                align: 'center'
                            },
                            labels:element.Labels
                        },
                        series:element.Series
                    }
                    if (element.Idioma=='ESP') {
                        res.data.data.DatosGraficaParejas.PreguntasParejasEsp.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    else{
                        res.data.data.DatosGraficaParejas.PreguntasParejasEng.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    contador++;
                });
                res.data.data.DatosGraficaParejas.OpcionesValoracion.forEach((element)=>{
                    let Labels=[];
                    let Values=[];
                    element.Datos.forEach((Dato)=>{
                        Labels.push(Dato.label);
                        Values.push(Dato.value);
                    });
                    let Grafica={
                        type:'line',
                        width:'80%',
                        options:{
                            chart:{
                                id:'grafica'+contador,
                                offsetX:60
                            },
                            stroke:{
                                curve:'smooth',
                                width:3
                            },
                            dataLabels:{
                                enabled:true,
                                background:{
                                    borderRadius:10
                                }
                            },
                            fill:{
                                colors:['#3B97B2']
                            },
                            xaxis:{
                                categories:Labels
                            },
                            title: {
                                text: 'Puntuación por Pregunta',
                                align: 'center'
                            },
                        },
                        series: [{
                            name: "Votos de Personas",
                            data: Values,
                            color:"#3B97B2"
                        }],
                    }
                    if (element.Idioma=='ESP') {
                        res.data.data.DatosGraficaParejas.PreguntasParejasEsp.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    else{
                        res.data.data.DatosGraficaParejas.PreguntasParejasEng.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    contador++;
                });
                res.data.data.DatosGraficaParejas.OpcionesSiNo.forEach((element)=>{
                    let Grafica={
                        type:'bar',
                        width:'80%',
                        options:{
                            chart:{
                                id: 'grafica'+contador,
                                stacked: true,
                                stackType: '100%',
                                offsetX:70
                            },
                            xaxis:{
                                categories:element.Labels
                            },
                            title: {
                                text: 'Porcentaje de Respuesta SI - NO',
                                align: 'center'
                            },
                        },
                        series:[
                            {
                                name:'SI',
                                data:element.SerieSi
                            },
                            {
                                name:'NO',
                                data:element.SerieNo
                            },
                        ]
                    }
                    if (element.Idioma=='ESP') {
                        res.data.data.DatosGraficaParejas.PreguntasParejasEsp.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    else{
                        res.data.data.DatosGraficaParejas.PreguntasParejasEng.push({IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,Pregunta:element.Pregunta,Grafica:Grafica});
                    }
                    contador++;
                });
                res.data.data.DatosGraficaParejas.OpcionesAbiertas.forEach((element)=>{
                    if (element.Idioma=='ESP') {
                        res.data.data.DatosGraficaParejas.PreguntasParejasEsp.push(
                            {
                                IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,
                                Pregunta:element.Pregunta,
                                Respuestas:element.Respuestas
                            }
                        );
                    }
                    else{
                        res.data.data.DatosGraficaParejas.PreguntasParejasEng.push(
                            {
                                IdConfigEncuestaPregunta:element.IdConfigEncuestaPregunta,
                                Pregunta:element.Pregunta,
                                Respuestas:element.Respuestas
                            }
                        );
                    }
                });
                res.data.data.DatosGrafica.Preguntas.sort((a,b)=>a.IdConfigEncuestaPregunta-b.IdConfigEncuestaPregunta);
                res.data.data.DatosGraficaParejas.PreguntasParejasEsp.sort((a,b)=>a.IdConfigEncuestaPregunta-b.IdConfigEncuestaPregunta);
                res.data.data.DatosGraficaParejas.PreguntasParejasEng.sort((a,b)=>a.IdConfigEncuestaPregunta-b.IdConfigEncuestaPregunta);
                this.ObjEncuestas.ListaPreguntas=res.data.data.DatosGrafica.Preguntas;
                this.ObjEncuestas.ListaPreguntasParejasEsp=res.data.data.DatosGraficaParejas.PreguntasParejasEsp;
                this.ObjEncuestas.ListaPreguntasParejasEng=res.data.data.DatosGraficaParejas.PreguntasParejasEng;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        async GetFiltros(){
            await this.$http.get('encuestaGraficaFiltros'
            ).then((res)=>{
                this.Clientes=res.data.data.Clientes;
                this.Contactos=res.data.data.Contactos;
                this.Vendedores=res.data.data.Vendedores;
                this.Anios=res.data.data.Anios; 
            })
        },
        CambiarRango(){
            if (this.BndRango==false) {
                this.BndRango=true;
                this.Filtro.Anio='';
                this.Filtro.Mes='';
            }
            else{
                this.BndRango=false;
                this.Filtro.Anio=new Date().getFullYear();
                this.Filtro.Inicio='';
                this.Filtro.Fin='';
            }
            this.Filtro.Rango=this.BndRango;
        }
    },
    created() {
    },
    mounted() {
        this.GetFiltros();
        this.GetDatosGraficas();
    },
}
</script>

<style>

</style>